import { render } from "./PersonalInfoForm.vue?vue&type=template&id=045c1d0a&scoped=true"
import script from "./PersonalInfoForm.vue?vue&type=script&lang=js"
export * from "./PersonalInfoForm.vue?vue&type=script&lang=js"

import "./PersonalInfoForm.vue?vue&type=style&index=0&id=045c1d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045c1d0a"]])

export default __exports__